import app from "@/main";
import _ from "lodash-es";

export default class Url {
  static get domain(): string {
    const host: string = location.host;
    host.indexOf(":") ? host.substr(0, host.indexOf(":")) : host;
    const hostArray = host.split(".");
    let domain = host;
    const len = hostArray.length;
    if (len > 2 && !parseInt(hostArray[len - 1])) {
      domain = "." + _.join([hostArray[len - 2], hostArray[len - 1]], ".");
    }
    return domain;
  }
  static parseQuery(s: string): { [key: string]: string } {
    const start = s.indexOf("?");
    if (start > 0) {
      s = s.slice(start + 1);
    }
    const query: { [key: string]: string } = {};
    const paramsArray = s.split("&");
    paramsArray.map(paramString => {
      const kv = paramString.split("=");
      const k = kv[0];
      let v = kv[1] ? kv[1] : "";
      v = decodeURIComponent(v);
      query[k] = v;
    });
    return query;
  }

  static buildQuery(query: any): string {
    const a = new Array<string>();
    for (const k in query) {
      const v = query[k];
      a.push(k + "=" + encodeURIComponent(v));
    }
    const s = a.join("&");
    return s;
  }
  static queries(search: string): Map<string, string> {
    const start = search.indexOf("?");
    const params = new Map<string, string>();
    if (start >= 0) {
      const queryString = search.slice(start + 1);
      const paramsArray = queryString.split("&");
      paramsArray.map(paramString => {
        const kv = paramString.split("=");
        const k = kv[0];
        let v = kv[1] ? kv[1] : "";
        v = decodeURIComponent(v);
        params.set(k, v);
      });
    }
    return params;
  }
  static query(name: string): string {
    const params = this.queries(location.search);
    return params.get(name) || "";
  }
  static setQuery(key: string, value: string) {
    const params = this.queries(location.search);
    if (params.get(key) === value) {
      return;
    }
    params.set(key, value);
    const paramsArray = new Array<string>();
    params.forEach((v, k) => {
      paramsArray.push(k + "=" + encodeURIComponent(v));
    });
    const queryString = paramsArray.join("&");
    //不敢改原来逻辑。。。 先套一层判断：报告页不重置
    const url = document.URL;
    if (
      url.includes("candidates-info") ||
      url.includes("candidate-infos") ||
      url.includes("candidate-info") ||
      url.includes("-nr") ||
      url.includes("mark") ||
      url.includes("public")
    ) {
      return;
    }

    app.$router.replace("?" + queryString);
  }
  //只设置url参数 不跳转
  static setQueryOnly(key: string, value: string) {
    const params = this.queries(location.search);
    if (params.get(key) === value) {
      return;
    }
    params.set(key, value);
    const paramsArray = new Array<string>();
    params.forEach((v, k) => {
      paramsArray.push(k + "=" + encodeURIComponent(v));
    });
    const queryString = paramsArray.join("&");
    const url = document.location.origin + document.location.pathname;
    history.replaceState(null, "", url + "?" + queryString);
  }
}
